<script setup>
import AppCard from './layouts/AppCard.vue';

const props = defineProps({
  milestones: Array,
  readinessAssessmentId: Number || String,
  title: String,
  completedAt: String,
  assessmentNote: String,
})

const achievementText = (achievementLevel) => {
    switch (achievementLevel) {
        case 0:
            return 'NO'
        case 1:
            return 'MAYBE'
        case 2:
            return 'YES'
        default:
            return 'NO'
    }
}



</script>
<template>
    <AppCard :header="props.title" :back-button="true" :subheader="props.completedAt">
      <div class="">
        <div v-if="props.assessmentNote" class="border border-gray-800 text-gray-500 rounded-xl p-2 my-2">
          {{ props.assessmentNote }}
        </div>
        <div v-for="assessmentMilestone in props.milestones" class="border border-black bg-white text-black text-sm font-bold flex flex-col rounded-xl p-2 mb-2">
          <div class="mb-2">{{ assessmentMilestone.milestone.readiness_milestone.title }}</div>
          <div class="mb-2">{{ achievementText(assessmentMilestone.milestone.achievement_level) }}</div>
          <div class="border border-gray-800 text-gray-500 rounded-xl p-2" v-if="assessmentMilestone.note"> {{ assessmentMilestone.note.content }}</div>
        </div>
      </div>
    </AppCard>
</template>